/*
  Cherryaffairs search redirects
  Generated from redirects(1).csv
  Terms: 455 exact-match redirects
  Checksum: b3828e7fb641

  Behavior:
  - Intercepts Shopify search form submissions only.
  - Exact-match only after trim + lowercase + whitespace collapse.
  - Non-matching searches continue to normal Shopify search.
  - Does not affect predictive search/autocomplete because it only runs on submit.
*/
(function () {
  'use strict';

  const REDIRECTS = new Map([
    ["101 delay spray", "/collections/delay-sprays"],
    ["50 shades of grey", "/collections/fifty-shades-of-grey"],
    ["adam & eve", "/collections/adam-eve"],
    ["adam and eve", "/collections/adam-eve"],
    ["adam eve", "/collections/adam-eve"],
    ["adjustable handcuffs", "/collections/hand-leg-cuffs"],
    ["adult gift", "/collections/date-night-gifts"],
    ["adult party", "/collections/adult-party-supplies"],
    ["adult party games", "/collections/adult-party-games"],
    ["adult party supplies", "/collections/adult-party-supplies"],
    ["adult toy", "/collections/adult-wellness-singapore"],
    ["adult toy singapore", "/collections/adult-wellness-singapore"],
    ["adult toys", "/collections/adult-wellness-singapore"],
    ["adult toys singapore", "/collections/adult-wellness-singapore"],
    ["aloe cadabra", "/collections/aloe-cadabra"],
    ["anal beads", "/collections/beads"],
    ["anal beginner", "/collections/anal-dilators"],
    ["anal beginner kit", "/collections/beginners-kit"],
    ["anal lubricant", "/collections/anal-lube"],
    ["anal starter", "/collections/beginners-kit"],
    ["anal starter kit", "/collections/anal-dilators"],
    ["anal trainer", "/collections/anal-dilators"],
    ["anal training", "/collections/anal-dilators"],
    ["analyze enema", "/collections/anal-douche"],
    ["aneros", "/collections/aneros"],
    ["anniversary gift for partner", "/collections/date-night-gifts"],
    ["aphrodisiac", "/collections/arousal-gel"],
    ["app controlled couple toy", "/collections/long-distance-relationship-toys"],
    ["app controlled couples toy", "/collections/long-distance-relationship-toys"],
    ["app controlled toys", "/collections/app-controlled-toys"],
    ["app controlled vibrator", "/collections/app-controlled-toys"],
    ["app-controlled vibrator", "/collections/app-controlled-toys"],
    ["arcwave", "/collections/arcwave"],
    ["asian sex doll", "/collections/sex-doll"],
    ["astroglide", "/collections/astroglide"],
    ["auto blow", "/collections/autoblow"],
    ["automatic stroker", "/collections/sex-toys-for-him-masturbators-with-vibration"],
    ["b swish", "/collections/b-swish"],
    ["b vibe", "/collections/b-vibe"],
    ["b-swish", "/collections/b-swish"],
    ["b-vibe", "/collections/b-vibe"],
    ["bath mate", "/collections/bathmate"],
    ["bathmate", "/collections/bathmate"],
    ["bdsm set", "/collections/bdsm-set"],
    ["beads", "/collections/anal-beads"],
    ["bed restraint", "/collections/bed-restraint"],
    ["beginner", "/collections/beginner-friendly-picks"],
    ["beginner anal", "/collections/anal-dilators"],
    ["beginner sex toys", "/collections/beginner-friendly-picks"],
    ["ben wa balls", "/collections/kegel-balls"],
    ["benwa balls", "/collections/kegel-balls"],
    ["beppy", "/collections/beppy"],
    ["bijoux cosmetiques", "/collections/bijoux-cosmetiques"],
    ["bijoux de nip", "/collections/bijoux-de-nip"],
    ["bijoux de nipples", "/collections/bijoux-de-nip"],
    ["bijoux indiscrets", "/collections/bijoux-indiscrets"],
    ["bluetooth vibrator", "/collections/app-controlled-toys"],
    ["blush novelties", "/collections/blush-novelties"],
    ["bms", "/collections/bms"],
    ["bodystocking", "/collections/lingerie"],
    ["bodywand", "/collections/bodywand"],
    ["bondage rope", "/collections/rope"],
    ["bswish", "/collections/b-swish"],
    ["butt plugs", "/collections/butt-plug"],
    ["buy sex toys", "/collections/adult-wellness-singapore"],
    ["buy sex toys singapore", "/collections/adult-wellness-singapore"],
    ["bvibe", "/collections/b-vibe"],
    ["cable", "/collections/cable"],
    ["california exotics", "/collections/california-exotics"],
    ["calexotics", "/collections/california-exotics"],
    ["cbx", "/collections/cbx"],
    ["chain nipple clamps", "/collections/nipple-clamps"],
    ["chastity belt", "/collections/cock-cage"],
    ["chemise", "/collections/chemises"],
    ["chemises", "/collections/chemises"],
    ["clandestine", "/collections/clandestine"],
    ["cleaner", "/collections/toy-cleaners"],
    ["clit suck", "/collections/clitoral-air-stimulators"],
    ["clit suction", "/collections/clitoral-air-stimulators"],
    ["clitoral air", "/collections/clitoral-air-stimulators"],
    ["clitoral clamp", "/collections/nipple-clamps"],
    ["cock sleeve", "/collections/cock-sleeves"],
    ["cocksleeve", "/collections/cock-sleeves"],
    ["collar", "/collections/leash"],
    ["collars", "/collections/leash"],
    ["colt", "/collections/colt"],
    ["condom and lube", "/collections/lubes-condoms"],
    ["condoms and lube", "/collections/lubes-condoms"],
    ["condoms and protection", "/collections/safe-sex"],
    ["cooling gel", "/collections/cooling-lube"],
    ["cooling lube", "/collections/cooling-lube"],
    ["cooling lubricant", "/collections/cooling-lube"],
    ["coquette", "/collections/coquette"],
    ["corset", "/collections/lingerie"],
    ["costume", "/collections/costumes"],
    ["costumes", "/collections/costumes"],
    ["couple gift", "/collections/date-night-gifts"],
    ["couple vibrator", "/collections/sex-toys-for-them-couples-vibrators"],
    ["couples games", "/collections/adult-party-games"],
    ["couples gift", "/collections/date-night-gifts"],
    ["couples gift set", "/collections/gift-sets"],
    ["couples play", "/collections/sex-toys-for-couples"],
    ["couples sex toys", "/collections/sex-toys-for-couples"],
    ["coupon code", "/collections/mega-sale"],
    ["cream delayer", "/collections/delay-sprays"],
    ["creative conceptions", "/collections/creative-conceptions"],
    ["crotchless", "/collections/crotchless-panties"],
    ["crotchless panties", "/collections/crotchless-panties"],
    ["crown condoms", "/collections/condoms"],
    ["delay", "/collections/delayer"],
    ["delay cream", "/collections/delay-sprays"],
    ["delivery cost", "/pages/packaging-and-delivery-policy"],
    ["delivery fee", "/pages/packaging-and-delivery-policy"],
    ["detachable clitoral sucking vibrator", "/collections/clitoral-air-stimulators"],
    ["dick torso", "/collections/sex-doll"],
    ["dildo", "/collections/dildos-dongs"],
    ["dildo suction", "/collections/suction-cup-dildo"],
    ["dildo suction cup", "/collections/suction-cup-dildo"],
    ["dildo torso", "/collections/sex-doll"],
    ["dildos", "/collections/dildos-dongs"],
    ["discount code", "/collections/mega-sale"],
    ["discreet delivery", "/pages/packaging-and-delivery-policy"],
    ["discreet delivery singapore", "/pages/discreet-packaging"],
    ["discreet packaging", "/pages/discreet-packaging"],
    ["discreet vibrator", "/collections/discreet-sex-toys"],
    ["doc johnson", "/collections/doc-johnson"],
    ["doki doki", "/collections/doki-doki"],
    ["doll torso", "/collections/sex-doll"],
    ["dong", "/collections/dildos-dongs"],
    ["dorcel", "/collections/dorcel"],
    ["dots textured condoms", "/collections/condoms"],
    ["doxy", "/collections/doxy"],
    ["dreamgirl", "/collections/dreamgirl"],
    ["dress", "/collections/dresses"],
    ["dresses", "/collections/dresses"],
    ["durex", "/collections/durex"],
    ["e-stim", "/collections/electrosex"],
    ["electric stroker", "/collections/sex-toys-for-him-masturbators-with-vibration"],
    ["electro sex", "/collections/electrosex"],
    ["electrosex", "/collections/electrosex"],
    ["energizer", "/collections/energizer"],
    ["erocome", "/collections/erocome"],
    ["essentials", "/collections/sex-essentials"],
    ["estim", "/collections/electrosex"],
    ["evolved", "/collections/evolved"],
    ["exe", "/collections/exe"],
    ["extender", "/collections/penis-pumps"],
    ["eye of love", "/collections/eye-of-love"],
    ["female orgasm", "/collections/stronger-female-orgasm"],
    ["female sex toys", "/collections/sex-toys-for-her"],
    ["female vibrator", "/collections/vibrators"],
    ["feminine hygiene", "/collections/personal-hygiene"],
    ["fifty shades", "/collections/fifty-shades-of-grey"],
    ["fifty shades of grey", "/collections/fifty-shades-of-grey"],
    ["finger condom", "/collections/finger-cots"],
    ["finger dome cots", "/collections/finger-cots"],
    ["flavored lube", "/collections/flavored-lube"],
    ["flavored lubricant", "/collections/flavored-lube"],
    ["flavoured lube", "/collections/flavored-lube"],
    ["flavoured lubricant", "/collections/flavored-lube"],
    ["fleshlight", "/collections/fleshlight"],
    ["flogger", "/collections/flogger"],
    ["foreplay", "/collections/better-foreplay"],
    ["fun factory", "/collections/fun-factory"],
    ["g project", "/collections/g-project"],
    ["g spot", "/collections/g-spot-vibrators"],
    ["g string", "/collections/lingerie"],
    ["galaku", "/collections/galaku"],
    ["garter", "/collections/wearables"],
    ["garters", "/collections/wearables"],
    ["gay sex doll", "/collections/sex-doll"],
    ["gay sex toys", "/collections/sex-toys-for-him-gay-toys"],
    ["gay toys", "/collections/sex-toys-for-him-gay-toys"],
    ["gift set", "/collections/gift-sets"],
    ["gift sets", "/collections/gift-sets"],
    ["glas", "/collections/glas"],
    ["glass dildo", "/collections/glass-sex-toys"],
    ["glass dildos", "/collections/glass-sex-toys"],
    ["glass sex toys", "/collections/glass-sex-toys"],
    ["glass toy", "/collections/glass-sex-toys"],
    ["gun oil", "/collections/gun-oil"],
    ["gunoil", "/collections/gun-oil"],
    ["half doll", "/collections/sex-doll"],
    ["hand cuff", "/collections/hand-leg-cuffs"],
    ["hand cuffs", "/collections/hand-leg-cuffs"],
    ["handy", "/collections/handy"],
    ["hollow strap", "/collections/sex-toys-for-them-strap-on"],
    ["hollow strap on", "/collections/sex-toys-for-them-strap-on"],
    ["hot octopus", "/collections/hot-octopuss"],
    ["hot octopuss", "/collections/hot-octopuss"],
    ["hotoctopuss", "/collections/hot-octopuss"],
    ["hybrid lube", "/collections/hybrid-lube"],
    ["hybrid lubricant", "/collections/hybrid-lube"],
    ["hydro7 penis pump", "/collections/bathmate"],
    ["hydromax", "/collections/bathmate"],
    ["hydromax8 penis pump", "/collections/bathmate"],
    ["hydromax9 penis pump", "/collections/bathmate"],
    ["icon brands", "/collections/icon-brands"],
    ["inspire dilator kit", "/collections/vaginal-dilator-kit"],
    ["intimate earth", "/collections/intimate-earth"],
    ["intimate essentials", "/collections/sex-essentials"],
    ["intimate gift", "/collections/date-night-gifts"],
    ["intimate hygiene", "/collections/personal-hygiene"],
    ["jack rabbit", "/collections/rabbit-vibrators"],
    ["japan onahole", "/collections/masturbator-japan-onahole"],
    ["japanese onahole", "/collections/masturbator-japan-onahole"],
    ["jimmyjane", "/collections/jimmy-jane"],
    ["jo lube", "/collections/system-jo"],
    ["jockstrap", "/collections/lingerie"],
    ["kegel ball", "/collections/kegel-balls"],
    ["kegel balls", "/collections/kegel-balls"],
    ["kheper games", "/collections/kheper-games"],
    ["kiiroo", "/collections/kiiroo"],
    ["kmp", "/collections/kmp"],
    ["kokos", "/collections/kokos"],
    ["ky jelly", "/collections/ky-jelly"],
    ["last longer", "/collections/prolong-erection"],
    ["last longer in bed", "/collections/prolong-erection"],
    ["last longer spray", "/collections/prolong-erection"],
    ["latest toys", "/collections/new-arrivals"],
    ["leash", "/collections/leash"],
    ["leashes", "/collections/leash"],
    ["lelo", "/collections/lelo"],
    ["leten", "/collections/leten"],
    ["licking clitoral air stimulator", "/collections/clitoral-air-stimulators"],
    ["love honey", "/collections/love-honey"],
    ["lovehoney", "/collections/love-honey"],
    ["lovehoney beginner", "/collections/love-honey"],
    ["lovehoney blowmotion", "/collections/love-honey"],
    ["lovehoney lubricant", "/collections/love-honey"],
    ["lovehoney mantric", "/collections/love-honey"],
    ["lovense", "/collections/lovense"],
    ["lovsense", "/collections/lovense"],
    ["lube", "/collections/lubes"],
    ["lube condom bundle", "/collections/lubes-condoms"],
    ["lubes", "/collections/lubes"],
    ["lubricant", "/collections/lubes"],
    ["lubricants", "/collections/lubes"],
    ["luxury massage oil", "/collections/massage-oil-candle"],
    ["maccos japan", "/collections/maccos-japan"],
    ["magic eyes japan", "/collections/magic-eyes"],
    ["magic motion", "/collections/magic-motion"],
    ["male edge", "/collections/male-edge"],
    ["male lingerie", "/collections/mens-wear"],
    ["male sex toys", "/collections/sex-toys-for-him"],
    ["male sleeve", "/collections/cock-sleeves"],
    ["male torso", "/collections/sex-doll"],
    ["male vibrator", "/collections/male-vibrators"],
    ["male vibrators", "/collections/male-vibrators"],
    ["mask", "/collections/mask-blind"],
    ["massage gel", "/collections/massage-oil-candle"],
    ["master series", "/collections/master-series"],
    ["masturbator", "/collections/masturbators"],
    ["men lingerie", "/collections/mens-wear"],
    ["mens wear", "/collections/mens-wear"],
    ["menstrual cup", "/collections/menstrual-cup"],
    ["metal butt plug", "/collections/butt-plug"],
    ["mini bullet", "/collections/bullets"],
    ["motorized stroker", "/collections/sex-toys-for-him-masturbators-with-vibration"],
    ["mouth gag", "/collections/ball-gag"],
    ["naturals massage oil", "/collections/massage-oil-candle"],
    ["new arrivals", "/collections/new-arrivals"],
    ["new products", "/collections/new-arrivals"],
    ["new toys", "/collections/new-arrivals"],
    ["nexus", "/collections/nexus"],
    ["nipple dome vibrator massager", "/collections/sex-toys-for-her-pumps"],
    ["nipple pump", "/collections/sex-toys-for-her-pumps"],
    ["nipple sucker", "/collections/sex-toys-for-her-pumps"],
    ["nipplettes clamps", "/collections/nipple-clamps"],
    ["njoy", "/collections/njoy"],
    ["njoy toys", "/collections/njoy"],
    ["nomi", "/collections/sex-toys-for-her-nomi-tang"],
    ["nomi tang", "/collections/nomi-tang"],
    ["npg", "/collections/npg"],
    ["npg julia", "/collections/npg"],
    ["npg panties", "/collections/npg"],
    ["npg thong", "/collections/npg"],
    ["npg waka", "/collections/npg"],
    ["ns", "/collections/ns-novelties"],
    ["ns novelties", "/collections/ns-novelties"],
    ["nsn", "/collections/ns-novelties"],
    ["nu sensuelle", "/collections/nu-sensuelle"],
    ["oh mi bod", "/collections/ohmibod"],
    ["ohmibod", "/collections/ohmibod"],
    ["ohmybod", "/collections/ohmibod"],
    ["okamoto", "/collections/okamoto"],
    ["onahole", "/collections/masturbator-japan-onahole"],
    ["onaholes", "/collections/masturbator-japan-onahole"],
    ["online sex toys", "/collections/adult-wellness-singapore"],
    ["online sex toys singapore", "/collections/adult-wellness-singapore"],
    ["open crotch panties", "/collections/crotchless-panties"],
    ["oral sex toy clit massager", "/collections/clitoris-massagers"],
    ["orgie", "/collections/orgie"],
    ["oxballs", "/collections/oxballs"],
    ["paddle", "/collections/bdsm"],
    ["pantyhose", "/collections/stockings"],
    ["partner vibrator", "/collections/sex-toys-for-them-couples-vibrators"],
    ["penis extender", "/collections/penis-pumps"],
    ["penis massager", "/collections/male-vibrators"],
    ["penis sleeve", "/collections/cock-sleeves"],
    ["penis vibrator", "/collections/male-vibrators"],
    ["perfect fit", "/collections/perfect-fit"],
    ["personal hygiene", "/collections/personal-hygiene"],
    ["personal lubricant", "/collections/lubes"],
    ["pheromone", "/collections/pheromones"],
    ["pheromone perfume", "/collections/pheromones"],
    ["pheromones", "/collections/pheromones"],
    ["pipedream", "/collections/pipedream"],
    ["pjur lust", "/collections/pjur"],
    ["plain packaging", "/pages/discreet-packaging"],
    ["playboy", "/collections/playboy"],
    ["pleasure her", "/collections/pleasuring-a-woman"],
    ["pleasuring her", "/collections/pleasuring-a-woman"],
    ["postrate massager", "/collections/prostate-massagers"],
    ["power rings cock ring", "/collections/cock-rings"],
    ["ppp", "/collections/ppp"],
    ["pretty love", "/collections/pretty-love"],
    ["prisoner metal chastity cock cage", "/collections/cock-cage"],
    ["private delivery", "/pages/discreet-packaging"],
    ["private packaging", "/pages/discreet-packaging"],
    ["promo code", "/collections/mega-sale"],
    ["pussy torso", "/collections/sex-doll"],
    ["realistic dildo", "/collections/realistic-dildo-dongs"],
    ["realistic dong", "/collections/realistic-dildo-dongs"],
    ["realistic dongs", "/collections/realistic-dildo-dongs"],
    ["remote control wearable panty vibrator", "/collections/vibrating-lingerie"],
    ["remote couple toy", "/collections/long-distance-relationship-toys"],
    ["remote couples vibrator", "/collections/long-distance-relationship-toys"],
    ["remote double dildo", "/collections/sex-toys-for-them-double-dildo"],
    ["remote vibrator", "/collections/remote-vibrators"],
    ["rene rofe", "/collections/rene-rofe"],
    ["ride japan", "/collections/ride-japan"],
    ["rocks off", "/collections/rocksoff"],
    ["rocksoff", "/collections/rocksoff"],
    ["role play costume", "/collections/costumes"],
    ["role-play costume", "/collections/costumes"],
    ["romp", "/collections/romp"],
    ["safe sex", "/collections/safe-sex"],
    ["safe sex kit", "/collections/lubes-condoms"],
    ["safe sex protection", "/collections/safe-sex"],
    ["satisfyer", "/collections/satisfyer"],
    ["selopa", "/collections/selopa"],
    ["sensation condoms", "/collections/condoms"],
    ["sensuva", "/collections/sensuva"],
    ["serum desensitizing delayer", "/collections/delay-sprays"],
    ["sex dice", "/collections/adult-party-games"],
    ["sex doll dick", "/collections/sex-doll"],
    ["sex doll men", "/collections/sex-doll"],
    ["sex doll torso", "/collections/sex-doll"],
    ["sex essentials", "/collections/sex-essentials"],
    ["sex games", "/collections/adult-party-games"],
    ["sex toy", "/collections/adult-wellness-singapore"],
    ["sex toy gift set", "/collections/gift-sets"],
    ["sex toy singapore", "/collections/adult-wellness-singapore"],
    ["sex toys", "/collections/adult-wellness-singapore"],
    ["sex toys for men", "/collections/sex-toys-for-him"],
    ["sex toys for women", "/collections/sex-toys-for-her"],
    ["sex toys singapore", "/collections/adult-wellness-singapore"],
    ["sexy chemise", "/collections/chemises"],
    ["sexy costume", "/collections/costumes"],
    ["sexy gift", "/collections/date-night-gifts"],
    ["shipping cost", "/pages/packaging-and-delivery-policy"],
    ["shipping fee", "/pages/packaging-and-delivery-policy"],
    ["shunga", "/collections/shunga"],
    ["silicone based lube", "/collections/lube-silicone-based"],
    ["silicone lube", "/collections/lube-silicone-based"],
    ["silicone lubricant", "/collections/lube-silicone-based"],
    ["silicone-based lubricant", "/collections/lube-silicone-based"],
    ["sliquid", "/collections/sliquid"],
    ["smart vibrator", "/collections/app-controlled-toys"],
    ["spice things up", "/collections/spicing-up-sex-life"],
    ["spice up sex life", "/collections/spicing-up-sex-life"],
    ["sportsheets", "/collections/sportsheets"],
    ["ssi", "/collections/ssi-japan"],
    ["ssi japan", "/collections/ssi-japan"],
    ["stocking", "/collections/wearables"],
    ["stockings", "/collections/wearables"],
    ["strapless harness", "/collections/sex-toys-for-them-strap-on"],
    ["strapless strap on", "/collections/sex-toys-for-them-strap-on"],
    ["superhero delay serum spray", "/collections/delay-sprays"],
    ["svakom", "/collections/svakom"],
    ["swiss navy", "/collections/swiss-navy"],
    ["system jo", "/collections/system-jo"],
    ["tenga", "/collections/tenga"],
    ["tenga 360", "/collections/tenga"],
    ["tenga flip", "/collections/tenga"],
    ["tenga pocket", "/collections/tenga"],
    ["tenga soap", "/collections/tenga"],
    ["tenga stamina", "/collections/tenga"],
    ["tenga train", "/collections/tenga"],
    ["tenga training", "/collections/tenga"],
    ["the handy", "/collections/handy"],
    ["thehandy", "/collections/handy"],
    ["thigh high", "/collections/wearables"],
    ["thigh high stockings o s", "/collections/stockings"],
    ["thigh highs", "/collections/wearables"],
    ["thongs", "/collections/lingerie"],
    ["thrusting dildo 10", "/collections/thrusting-dildo"],
    ["thrusting vibrator", "/collections/thrusting-dildo"],
    ["tomax", "/collections/tomax"],
    ["torso dildo", "/collections/sex-doll"],
    ["torso doll", "/collections/sex-doll"],
    ["torso male", "/collections/sex-doll"],
    ["toy storage bag", "/collections/storage"],
    ["toyjoy", "/collections/toyjoy"],
    ["toys for couples", "/collections/sex-toys-for-couples"],
    ["toys for men gay", "/collections/sex-toys-for-him-gay-toys"],
    ["toys heart", "/collections/toysheart"],
    ["toysheart", "/collections/toysheart"],
    ["tracy dog", "/collections/tracys-dog"],
    ["tracydog", "/collections/tracys-dog"],
    ["ultra maximum delay", "/collections/delay-sprays"],
    ["ultraskyn", "/collections/condoms"],
    ["unmarked packaging", "/pages/discreet-packaging"],
    ["vagina masturbator", "/collections/masturbator-vagina"],
    ["vedo", "/collections/vedo"],
    ["vibrating anal", "/collections/anal-toys"],
    ["vibrating butt plug", "/collections/butt-plug"],
    ["vibrating panties", "/collections/vibrating-lingerie"],
    ["vibrating stroker", "/collections/sex-toys-for-him-masturbators-with-vibration"],
    ["vibrator", "/collections/vibrators"],
    ["vibrator singapore", "/collections/vibrators"],
    ["vibrator wand", "/collections/wand-massagers"],
    ["vibrators", "/collections/vibrators"],
    ["vibrators singapore", "/collections/vibrators"],
    ["voucher code", "/collections/mega-sale"],
    ["wand massager", "/collections/wand-massagers"],
    ["wand vibrator", "/collections/wand-massagers"],
    ["warmer", "/collections/warmer"],
    ["warming", "/collections/warming-lube"],
    ["water based lube", "/collections/lube-water-based"],
    ["we vibe", "/collections/we-vibe"],
    ["we-vibe", "/collections/we-vibe"],
    ["wearable couple vibrator", "/collections/sex-toys-for-them-couples-vibrators"],
    ["wearable couples toy", "/collections/sex-toys-for-them-couples-vibrators"],
    ["wearable vaginal dilator set", "/collections/vaginal-dilator-kit"],
    ["wevibe", "/collections/we-vibe"],
    ["wicked", "/collections/wicked"],
    ["wild one", "/collections/wild-one"],
    ["wireless vibrator", "/collections/app-controlled-toys"],
    ["wishlist", "/pages/wishlist"],
    ["womanizer", "/collections/womanizer"],
    ["womanizer duo", "/collections/womanizer"],
    ["womanizer x lovehoney pro40", "/collections/love-honey"],
    ["women vibrator", "/collections/vibrators"],
    ["wrist cuffs", "/collections/hand-leg-cuffs"],
    ["xl condoms", "/collections/condoms"],
    ["zero tolerance", "/collections/zero-tolerance"]
  ]);

  // CherryAffairs 2026-09-07: exact families, not broad query overrides.
  [["fleshlight girls","/collections/fleshlight-girls"],["fleshlight girl","/collections/fleshlight-girls"],["fleshlite girls","/collections/fleshlight-girls"],["flesh lite girls","/collections/fleshlight-girls"],["satisfyer pro 2","/collections/satisfyer-pro-2-series"],["satisfyer pro2","/collections/satisfyer-pro-2-series"],["satisfier pro 2","/collections/satisfyer-pro-2-series"],["satisfier pro2","/collections/satisfyer-pro-2-series"],["satisfyer pro ii","/collections/satisfyer-pro-2-series"],["lelo sona","/collections/lelo-sona-cruise-clit-massagers"],["lelo soan","/collections/lelo-sona-cruise-clit-massagers"],["lello sona","/collections/lelo-sona-cruise-clit-massagers"],["lelo sona cruise","/collections/lelo-sona-cruise-clit-massagers"],["sona cruise","/collections/lelo-sona-cruise-clit-massagers"],["lovense ferri","/products/lovense-ferri-app-controlled-panty-vibrator-pink"],["lovsense ferri","/products/lovense-ferri-app-controlled-panty-vibrator-pink"],["lovense ferry","/products/lovense-ferri-app-controlled-panty-vibrator-pink"],["ferri","/products/lovense-ferri-app-controlled-panty-vibrator-pink"],["we vibe sync","/collections/we-vibe-sync"],["wevibe sync","/collections/we-vibe-sync"],["we-vibe sync","/collections/we-vibe-sync"],["we vibe syn","/collections/we-vibe-sync"],["wevibe syn","/collections/we-vibe-sync"],["we vibe synch","/collections/we-vibe-sync"]].forEach(([query, destination]) => REDIRECTS.set(query, destination));

  // Exact Seiraku brand route; retain the existing normalized-submit behavior.
  REDIRECTS.set('seiraku', '/collections/seiraku-toys');

  function normalizeSearchTerm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function isSearchForm(form) {
    if (!form || form.matches('[data-search-redirect-disable]')) return false;

    const input = form.querySelector('input[name="q"]');
    if (!input) return false;

    const action = form.getAttribute('action') || window.location.pathname;

    try {
      const url = new URL(action, window.location.origin);
      return url.pathname === '/search' || url.pathname.endsWith('/search');
    } catch (error) {
      return action.indexOf('/search') !== -1;
    }
  }

  function pushAnalyticsEvent(searchTerm, destination) {
    
    try { window.CAEvidence?.push?.({
      event: 'search_redirect',
      search_term: searchTerm,
      redirect_to: destination
    }); } catch (_) { /* Tracking must never block navigation. */ }
  }

  document.addEventListener('submit', function (event) {
    const form = event.target && event.target.closest ? event.target.closest('form') : null;
    if (!isSearchForm(form) || event.defaultPrevented) return;
    if (form.querySelector('.predictive-search__item[aria-selected="true"]:not(.js-submit)')) return;

    const input = form.querySelector('input[name="q"]');
    const query = normalizeSearchTerm(input.value);
    if (!query) return;

    const route = REDIRECTS.get(query);
    if (!route) return;
    const actionPath = new URL(form.getAttribute('action') || '/search', window.location.origin).pathname;
    const localePrefix = actionPath.replace(/\/search\/?$/, '');
    const destination = localePrefix + route;

    event.preventDefault();
    pushAnalyticsEvent(query, destination);
    window.location.assign(destination);
  }, true);
})();
